export default "__VITE_ASSET__57b8950d__"